<template>
    <vx-expandable-card>
        <template v-slot:header>Integration Logs</template>
        <template v-slot:content>
            <p class="mb-4">View inbound webhook activity, errors, and contact data received from this integration.</p>
            <vx-button
                :href="`/settings/integrations/${props.vendor}/logs`"
                size="lg"
                block
                data-test="view-logs-button"
            >
                View Logs
            </vx-button>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxButton } from '@voxie/frontend-components';

const props = defineProps<{
    vendor: string;
}>();
</script>
